import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { useAlert, AlertProps } from '../../hooks';

export type CalloutProps = { objectId?: string } & Partial<
  Pick<AlertProps, 'variant' | 'isClosable' | 'showIcon' | 'onClose'>
> &
  Pick<AlertProps, 'title' | 'description'>;

export const Callout: React.FC<CalloutProps> = ({
  objectId = '',
  variant = 'success',
  isClosable = false,
  title,
  description,
  showIcon,
  onClose,
}) => {
  /**
   * Hooks
   */
  const showAlert = useAlert(variant, 'inline');
  /**
   * DOM
   */
  const objectType = useMemo(() => {
    if (!objectId) {
      return `core-callout`;
    }
    return `core-callout-${objectId}`;
  }, [objectId]);
  return (
    <Box
      data-object-type={objectType}
      className="core-callout"
      data-attribute={variant}
      role={variant === 'error' ? 'alert' : undefined}
    >
      {showAlert({
        id: `${variant}-callout`,
        title,
        description,
        isClosable,
        showIcon,
        onClose,
      })}
    </Box>
  );
};
